export default __webpack_public_path__ + "static/media/recipients_root_background.071959fd.jpg";